import { graphql, useStaticQuery } from 'gatsby'
import { useSiteId } from './useSiteId'

export const useLatestFeaturedArticle = () => {
  const data = useStaticQuery(graphql`
    {
      craftContent {
        articles: entries(
          section: "article"
          type: "default"
          siteId: [1, 2, 3]
          orderBy: "postDate DESC"
          isFeatured: true
        ) {
          ... on CraftContent_article_default_Entry {
            id
            title
            siteId
            slug
            postDate
            isFeatured
            articleBlocks {
              __typename
              ... on CraftContent_articleBlocks_magazineHeader_BlockType {
                id
                variant
                authorPhotographer
                headline
                lead
                image {
                  url
                }
              }
              ... on CraftContent_articleBlocks_magazineCopy_BlockType {
                id
                copyContent
              }
              ... on CraftContent_articleBlocks_magazineMediaContainer_BlockType {
                id
                images {
                  ... on CraftContent_images_BlockType {
                    id
                    image {
                      url
                    }
                    youtubeId
                    caption
                  }
                }
              }
              ... on CraftContent_articleBlocks_magazineStatement_BlockType {
                id
                text
                author
              }
            }
            referencedThemes {
              ... on CraftContent_theme_default_Entry {
                id
                title
              }
            }
            featureImage {
              ... on CraftContent_images_Asset {
                id
                url
                small_url: url(transform: "small")
              }
            }
          }
        }
      }
    }
  `)
  const siteId = useSiteId()
  const siteArticles = data.craftContent.articles.filter(
    node => node.siteId === siteId,
  )

  return siteArticles[0]
}
